import { AdministratorDto } from '@/src/models/AdministratorDto';
import DonationParticipantsDto from '@/src/models/DonationParticipantDto';
import { Media } from '@/src/models/MeidaDto';

export default class DonationDto {
  id: number;
  createdAt: string;
  updatedAt: string;
  deletedAt: string;
  // 모금 시작일
  startedAt: string;
  // 모금 종료일
  endedAt: string;
  // 노출여부
  isExposed: boolean;
  // 우선 노출 여부
  priorityDisplayYn: boolean;
  // 목표 크레딧
  goalCredit: number;
  // 참여 크레딧
  participantsCredit: number;
  // 최소 참여 크레딧
  minimumCredit: number;
  // 참여자 수
  participantsCnt: number;
  // 하단 버튼 여부
  bottomButtonDisplayYn: boolean;
  // 하단 버튼 명
  bottomButtonName: string;
  // 하단 버튼 링크
  bottomButtonLink: string;
  // 제목
  title: string;
  // 서브 제목
  subTitle: string;
  // 내용
  contents: string;
  // 종료 상태
  terminateStatus: any;
  // 제휴사 이미지
  sponsorImage: Media;
  // 제휴사 설명
  sponsorDescription: string;
  // 제휴사 링크
  sponsorLink: string;
  // 썸네일 이미지
  thumbnailImage: Media;
  // 등록 관리자
  administrator: AdministratorDto;

  // 기부 참여 정보
  donationParticipants?: DonationParticipantsDto;

  // 안내사항
  donationInfos: { id?: number; contents: string }[];
  // 유의사항
  donationCautions: { id?: number; contents: string }[];

  // 중복 참여 가능 여부
  allowDuplicateParticipant: boolean;
}
